import { render } from "./ticketStatusList.vue?vue&type=template&id=1c8000ad&scoped=true"
import script from "./ticketStatusList.vue?vue&type=script&lang=js"
export * from "./ticketStatusList.vue?vue&type=script&lang=js"

import "./ticketStatusList.vue?vue&type=style&index=0&id=1c8000ad&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8000ad"]])

export default __exports__